import { useContext } from "react"

//SOAR Context
import { UserContext } from "../../../context/userContext"

//Google components

import AutoComplete from "react-google-autocomplete"

//Helpers
import { LogError } from "../../../helpers/logger"

//Referral helper function
import { RefGetAddressFromPlace } from "../../Partner/Components/Input/RefTextInputGooglePlaces"
import { useField } from "formik"

export default function HouseAddressSearch() {
  const userCtx = useContext(UserContext)
  const [, , addressHelper] = useField("house.address")
  const [, , cityHelper] = useField("house.city")
  const [, , stateHelper] = useField("house.state")
  const [, , zipHelper] = useField("house.zipCode")

  const googlePlacesApiKey = userCtx.googlePlacesKey

  const setAddress = (selection) => {
    const selectedAddress = RefGetAddressFromPlace(selection)

    addressHelper.setValue(selectedAddress.address)
    cityHelper.setValue(selectedAddress.city)
    stateHelper.setValue(selectedAddress.state)
    zipHelper.setValue(selectedAddress.zipCode)
  }

  return (
    <>
      <div>
        <label>Search for house address</label>
        <div style={{ marginBottom: "10px" }}>
          <small style={{ color: "gray" }}>
            Enter the house address into the text box. Selecting the correct
            address will populate the address fields, alternatively enter the
            address manually
          </small>
        </div>
        <div className="col-12 md:col-10">
          <AutoComplete
            apiKey={googlePlacesApiKey}
            className="p-inputtext"
            style={{
              position: "relative",
              width: "100%",
              marginTop: "0px",
              marginBottom: "15px",
            }}
            options={{
              types: ["geocode", "establishment"],
            }}
            onPlaceSelected={(place) => setAddress(place)}
            onError={(error) => {
              LogError("GoogleAutoComplate error: " + error)
              userCtx.setNotificationError(
                `Unable to search for addresses, see console for details`
              )
            }}
          />
        </div>
      </div>
    </>
  )
}
